var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select2',{attrs:{"id":_vm.id,"name":_vm.name}},_vm._l((_vm.estados),function(estado){return _c('option',{domProps:{"value":estado.codigo}},[_vm._v("\n\t\t"+_vm._s(estado.descripcion)+"\n\t")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }